import { css } from 'lit';

export const styles = css`
  :host(:not(:last-child)) > div:not(.barrel-wrapper-closed) {
    padding-bottom: calc(40rem / var(--default-rem-px-count));
  }

  .barrel-wrapper-closed {
    height: calc(60rem / var(--default-rem-px-count));
    overflow: hidden;
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60rem / var(--default-rem-px-count));
    border-top: 2px solid #222222;
    cursor: pointer;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-weight: 500;
  }

  .barrel-header-icon {
    display: flex;
    justify-content: right;
    min-height: 2em;
    min-width: 2em;
  }

  .barrel-text {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    line-height: 1.45em;
  }

  /* MATERIAL BARREL */
  .material-row-wrapper {
    width: 100%;
    display: inline-grid;
    grid-template-columns:
      [mat-header]
      30%
      [mat-value]
      auto
      [end];
    padding-top: calc(24rem / var(--default-rem-px-count));
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    gap: 0 1em;
  }

  .material-row-wrapper:not(:last-child) {
    border-bottom: 1px solid var(--block-rule-color, #c0c0c0);
  }

  .material-row-wrapper:nth-child(2) {
    padding-top: calc(14rem / var(--default-rem-px-count));
  }

  .material-row-wrapper:last-child {
    padding-bottom: 0;
  }

  .material-row-header {
    grid-area: mat-header;
  }

  .material-row-value {
    grid-area: mat-value;
  }

  .row-content-text p:not(:last-child) {
    padding-bottom: calc(8rem / var(--default-rem-px-count));
  }

  /* DOWNLOADS BARREL */
  .downloads-wrapper {
    min-height: calc(30rem / var(--default-rem-px-count));
    display: flex;
    align-items: center;
  }

  .align-icon {
    padding-left: calc(6rem / var(--default-rem-px-count));
  }

  @media print {
    .barrel-header {
      border-top: 1px solid #222222;
    }

    .material-row-wrapper:not(:last-child) {
      border-bottom: 0.75px solid var(--block-rule-color, #c0c0c0);
    }

    .barrel-heavy-text {
      font-size: 10px;
      letter-spacing: -0.05px;
      line-height: 18px;
    }

    .material-row-wrapper p {
      font-size: 9px;
      letter-spacing: -0.05px;
      line-height: 12px;
    }
  }
`;
